export const timeFormatter = date => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return date ? formatter.format(date) : formatter.format(new Date());
};
